module.exports = __webpack_public_path__ + "static/media/BannerD6.daf324d7.png";